import * as React from 'react';
import { useIntl } from 'react-intl';
import { useSetRecoilState } from 'recoil';
import { getMapSettings, setMapSettings } from '../../../Services/UserService';
import useCrossTabState from '../../../hooks/useCrossTabState';
import { TMapType } from '../../../interfaces/map';
import { IUserMapSettings } from '../types';
import { saveMapSettings } from '../MapSettingsService';
import { mapInfoWindowMapSettingsAtom } from './VehicleChipsControl/InfoWindowState';
import useAnalytics from '../../../hooks/useAnalytics';
import { isNotDemo } from '../../../Services/DemoService';

interface IMapControl {
  map: google.maps.Map;
}

function MapControl(props: IMapControl): JSX.Element {
  const { formatMessage: f } = useIntl();
  const setMapSettingsValues = useSetRecoilState(mapInfoWindowMapSettingsAtom);
  const [mapType, setMapType] = useCrossTabState<TMapType>(
    'mapType',
    getMapSettings().value.mapType || 'roadmap'
  );
  const { trackEvent } = useAnalytics();

  const handleMapType = async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    const mapTypeId = event.currentTarget.getAttribute('data-map-type');
    if (mapTypeId) {
      trackEvent(['map', 'click', `Map type: ${mapTypeId}`]);
      props.map.setMapTypeId(mapTypeId);
      setMapSettingsValues((oldState: IUserMapSettings) => {
        const newState: IUserMapSettings = {
          ...oldState,
          value: {
            ...oldState.value,
            mapType: mapTypeId as TMapType,
          },
        };
        setMapSettings(newState);
        setMapType(mapTypeId as TMapType);
        return newState;
      });
      if (isNotDemo()) {
        await saveMapSettings(getMapSettings().value);
      }
    }
  };

  return (
    <a
      id="map-type-control"
      className="e-button-sq"
      title={`${
        mapType === 'roadmap'
          ? f({ id: 'maptype.map.control.satellite' })
          : f({ id: 'maptype.map.control.earth' })
      }`}
      onClick={handleMapType}
      data-map-type={mapType === 'roadmap' ? 'hybrid' : 'roadmap'}
    >
      <i
        className={`${
          mapType === 'roadmap' ? 'cmd-icon cmd-icon-satelite' : 'cmd-icons cmd-icon-earth'
        }`}
      />
    </a>
  );
}

export default MapControl;
